import { substituteFormName } from './form-interaction';

import type { FormSubmitSuccess } from '../types/events/form-submit-success';

export const createFormSubmitSuccessEvent = (
  formName: string,
): FormSubmitSuccess => {
  return {
    event_name: 'form-submit-success',
    form_name: substituteFormName(formName),
  };
};
